(function (app) {
  $(document).ready(function () {

    app.UserSocial = function () {

      var _this = this;
      var nameSpace = 'UserSocial',
        context = '.page__user-social-settings',
        dataTable = '.table__facebook-accounts-list',
        templates = {
          'facebookAccountRow': app.templates["User__partials____row-facebook-accounts"]
        },
        facebookConnected = $('[data-connected="facebook"]').is(":visible"),
        linkedInConnected = $('[data-connected="linkedIn"]').is(":visible"),
        twitterConnected = $('[data-connected="twitter"]').is(":visible")
        ;

      _this.updateList = function (response) {
        // Clean up all existing data in dom
        var $tableBody = $('.table__facebook-accounts-body', $(context).context);

        $tableBody.html('');
        $(dataTable).removeClass('loading-state');

        if (typeof response.accounts != 'undefined' && response.accounts.length) {
          _.each(response.accounts, function (row) {
            var dataRow = _.template(templates.facebookAccountRow);
            var $dataRow = $(
              dataRow(
                $.extend(row, {})
              )
            );
            $dataRow.appendTo($tableBody);
          });
        } else {

        }
      };

      _this.socialActions = function () {
        return {
          check: function () {
            var query = $.Deferred();
            var appTransport = app.transport();

            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.get('/api/social/check');
            return query.promise();
          },
          disconnect: function (provider) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/social/' + provider);
            return query.promise();
          },

          facebook: function () {
            return {
              get: function () {
                $(dataTable).addClass('loading-state');
                $('.page__no--records').hide();

                var query = $.Deferred();
                var appTransport = app.transport();

                appTransport
                  .setEvent('onSuccess', function (response) {
                    _this.updateList(response);
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.get('/api/social/facebook/accounts');
                return query.promise();
              },
              delete: function (accountId) {
                var query = $.Deferred();
                var appTransport = app.transport();
                appTransport
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.delete('/api/social/facebook/accounts/' + accountId);
                return query.promise();
              },
              update: function (accountId, requestData) {
                var query = $.Deferred();
                var appTransport = app.transport();
                appTransport
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.put('/api/social/facebook/accounts/' + accountId, requestData);
                return query.promise();
              }
            }
          }
        }
      };

      _this.getHash = function () {
        var hash = window.location.hash;
        return $.trim(hash.replace('#', ''));
      };

      _this.setHash = function (hash) {
        window.location.hash = hash;
      };

      return {
        init: function () {
          $(document).off('click.data-action' + nameSpace).on('click.data-action' + nameSpace, context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              accountId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              message = "Remove Page <b>" + $dataRow.find('.col__name').text() + "</b>";

            switch (action) {

              case 'trash':
                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Are you sure you want to proceed?')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    $.when(_this.socialActions().facebook().delete(accountId)).done(function () {
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');
                      $('.facebook-account-row[data-row=' + accountId + ']').remove();
                    }).fail(function () {
                      $button.button('reset');
                    });
                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                break;
            }

          }).off('click.data-disconnect' + nameSpace).on('click.data-disconnect' + nameSpace, context + ' [data-disconnect]', function (e) {
            var $button = $(this),
              provider = $button.attr('data-disconnect');

            var providerName = '';
            switch (provider) {
              case 'facebook' :
                providerName = 'Facebook';
                break;
              case 'linkedIn' :
                providerName = 'LinkedIn';
                break;
              case 'twitter' :
                providerName = 'Twitter';
                break;
            }

            var message = "Disconnecting your account will unschedule any pending posts to this " + providerName + " account ";

            $button.button('loading');
            alertify.confirm()
              .set({
                labels: {
                  ok: "Delete"
                }
              })
              .set({reverseButtons: true, transition: 'zoom', 'modal': true})
              .setHeader('Are you sure you want to proceed?')
              .set('message', message)
              .set('onok', function (e) {
                e.cancel = true;
                $('.ajs-button.ajs-ok').button('loading');
                $.when(_this.socialActions().disconnect(provider.toLowerCase())).done(function () {
                  alertify.confirm().close();
                  $('.ajs-button.ajs-ok').button('reset');
                  app.redirect('/my-account/app-user/social-settings', true);
                }).fail(function () {
                  $button.button('reset');
                });
              })
              .set('oncancel', function () {
                $button.button('reset');
              })
              .show();

          }).off('click.switch__' + nameSpace).on('click.switch__' + nameSpace, context + ' :input.custom-switch-input', function (e) {
            var $el = $(this),
              name = $(this).attr('name'),
              isChecked = $el.is(":checked"),
              id = $(this).attr('data-id')
              ;

            $.when(_this.socialActions().facebook().update(id, {active: isChecked})).done(function () {

            }).fail(function () {

            });

          });

          if (_.isEmpty(_this.getHash())) {
            _this.setHash('facebook');
          }

          /**
           * Open hashed tab
           */
          if (!_.isEmpty(_this.getHash())) {
            var tab = '';
            switch (_this.getHash()) {
              case 'facebook' :
                tab = '#tabFacebook';
                if (facebookConnected) {
                  $.when(_this.socialActions().facebook().get()).done(function (response) {

                  });
                }
                break;
              case 'linkedin' :
                tab = '#tabLinkedIn';
                break;
              case 'twitter' :
                tab = '#tabTwitter';
                break;
            }

            $('a[data-toggle="tab"][data-target="' + tab + '"]').tab('show');
          }

          $(document).on('shown.bs.tab', context + ' a[data-toggle="tab"]', function (e) {
            var $currentTarget = $(e.currentTarget);
            var tab = $currentTarget.attr('data-target');
            switch (tab) {
              case '#tabFacebook' :
                _this.setHash('facebook');
                if (facebookConnected) {
                  $.when(_this.socialActions().facebook().get()).done(function (response) {

                  });
                }
                break;
              case '#tabLinkedIn' :

                _this.setHash('linkedin');
                break;
              case '#tabTwitter' :
                _this.setHash('twitter');
                break;
            }
          });
        },

        global: function () {
          $.when(_this.socialActions().check()).done(function (response) {

            if(typeof response.socialProviders != 'undefined' ) {
              _.each(response.socialProviders, function(status, provider) {

                if(status != 'active') {
                  var socialError = _.template(app.templates["Social__partials____social-error"]);
                  var $socialError = $(
                    socialError(
                      {'provider' : provider, redirect : location.href}
                    )
                  );
                  $socialError.appendTo($('.page__global-message--container'));
                }
              });
            }

          });
        }
      }

    }

  });

})(PreBuilt);

// Call  global check for social connect
(function (app) {
  $(document).ready(function () {
    if($('.app__content').hasClass('app__has-identity')) {
      var appUserSocial = new app.UserSocial();
      appUserSocial.global();
    }
  });
})(PreBuilt);

